export const closingCross = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="closing-cross"
  >
    <g opacity="0.8">
      <path
        d="M15 5L5 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L15 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const circlePlus = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="circle-plus"
  >
    <path
      d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
      stroke="#969696"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4V8"
      stroke="#969696"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 6H8"
      stroke="#969696"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const logo = (
  <svg
    className="game__logo"
    xmlns="http://www.w3.org/2000/svg"
    width="202"
    height="59"
    fill="none"
  >
    <path
      fill="#000"
      d="M6.35 58.05c-1.89 0-3.38-.35-4.46-1.06C.77 56.3.2 55.4.2 54.3c0-1.02.38-1.98 1.15-2.88.77-.9 1.76-1.7 2.97-2.44a33.58 33.58 0 0 1 8.3-3.32c1.42-.35 2.65-.59 3.7-.72 1-.16 2.08-.28 3.27-.38l3.65-.29c1.24-.06 2.36-.1 3.36-.1a45.55 45.55 0 0 0 2.88-5.7c.76-1.8 1.44-3.86 2.01-6.2l.2-.77c-.61.58-1.48 1.28-2.6 2.12-1.09.8-2.37 1.61-3.84 2.44-1.44.8-2.99 1.48-4.65 2.02-1.64.54-3.32.82-5.04.82-2.28 0-4.24-.55-5.9-1.64a10.74 10.74 0 0 1-3.8-4.5c-.86-1.96-1.3-4.2-1.3-6.73 0-1.5.2-3.1.58-4.8.38-1.73 1-3.49 1.87-5.28-.99-1.02-1.77-2.16-2.35-3.4a9.52 9.52 0 0 1-.82-3.85c0-1.15.24-2.28.72-3.4a10.7 10.7 0 0 1 2.26-3.32c.29-.32.56-.48.82-.48.12 0 .19.07.19.2 0 .19-.11.41-.34.67A9.42 9.42 0 0 0 5.87 5.2a8.85 8.85 0 0 0 .1 6.29c.44 1.09 1.07 2.1 1.87 3.02a22.7 22.7 0 0 1 3.4-5.13 26.69 26.69 0 0 1 5.14-4.47 25.3 25.3 0 0 1 6.39-3.17c2.3-.8 4.7-1.2 7.2-1.2 3.32 0 5.95.72 7.87 2.16 1.95 1.44 2.93 3.62 2.93 6.53a8.4 8.4 0 0 1-1.16 4.13 11.74 11.74 0 0 1-3.4 3.8 18 18 0 0 1-5.67 2.78 28.2 28.2 0 0 1-7.82 1.15c-2.34.03-4.64-.26-6.91-.87a20.82 20.82 0 0 1-5.76-2.5 25.3 25.3 0 0 0-1.78 5c-.35 1.6-.53 3.1-.53 4.51 0 3.23.79 5.7 2.35 7.4 1.6 1.69 3.73 2.54 6.39 2.54 1.44 0 2.88-.21 4.32-.63a20.3 20.3 0 0 0 7.25-3.93c.9-.8 1.48-1.54 1.77-2.21.74-1.66 1.46-2.82 2.16-3.46.74-.67 1.4-1 1.97-1 .48 0 .88.22 1.2.67.35.41.48.99.38 1.73a25.67 25.67 0 0 1-2.2 7.72 71.58 71.58 0 0 1-4.37 8.12c2.17.03 4.13.14 5.85.33 1.76.23 3.35.51 4.76.87.38.1.64.2.76.33.16.16.24.29.24.39 0 .22-.19.33-.57.33-.2 0-.47-.05-.82-.14-.73-.2-1.71-.37-2.93-.53a85.83 85.83 0 0 0-7.92-.38 26.25 26.25 0 0 1-4.8 5.18 32.87 32.87 0 0 1-5.85 4.03 30.17 30.17 0 0 1-6.05 2.55c-1.95.6-3.71.9-5.28.9Zm15.07-38.4c2.18 0 4.29-.29 6.34-.87a21.04 21.04 0 0 0 5.52-2.4 13.52 13.52 0 0 0 3.89-3.55 7.35 7.35 0 0 0 1.48-4.37c0-1.4-.4-2.6-1.2-3.6a7.45 7.45 0 0 0-2.97-2.35 9.41 9.41 0 0 0-3.89-.81c-2.18 0-4.26.41-6.24 1.24a21.81 21.81 0 0 0-5.52 3.36 30.84 30.84 0 0 0-4.66 4.7 34.68 34.68 0 0 0-3.5 5.43c1.31 1 2.9 1.78 4.75 2.35 1.89.58 3.89.87 6 .87ZM6.25 56.8c1.25 0 2.72-.26 4.42-.77a29.7 29.7 0 0 0 10.66-5.71 24.03 24.03 0 0 0 4.5-4.85 52.1 52.1 0 0 0-8.98.77c-.79.13-1.78.37-2.96.72a33.64 33.64 0 0 0-7.16 3.17 12.6 12.6 0 0 0-2.68 2.16c-.68.77-1.01 1.55-1.01 2.35 0 .58.24 1.07.72 1.49.51.45 1.34.67 2.5.67ZM40.35 40a4.5 4.5 0 0 1-1.3-.24 3.08 3.08 0 0 1-1.3-.86 3.14 3.14 0 0 1-.53-1.97c0-.83.27-1.8.82-2.88l1.44-2.88c-.35 0-.53-.15-.53-.43.03-.1.18-.4.43-.92L40.3 28l1.01-2.02.82-1.53c.38-.7.99-1.06 1.82-1.06h2.98c-.55.42-1.04.88-1.5 1.4-.4.47-.93 1.37-1.57 2.68l-.34.67-.86 1.73-1.01 2.07-.82 1.77c-.41.9-.69 1.62-.81 2.16-.13.51-.2 1-.2 1.44 0 1.06.36 1.59 1.06 1.59.77 0 1.7-.63 2.78-1.88.9-1.05 1.78-2.32 2.64-3.79.87-1.47 1.68-2.99 2.45-4.56.8-1.57 1.5-2.97 2.11-4.22.36-.7.98-1.06 1.88-1.06h2.64c-.7.58-1.43 1.44-2.16 2.6a51.82 51.82 0 0 0-2.36 4.41c-.22.48-.5 1.09-.86 1.82-.35.74-.67 1.52-.96 2.36a8.45 8.45 0 0 0-.38 2.5c0 1.11.4 1.67 1.2 1.67 1.08 0 2.14-.75 3.16-2.25a33.83 33.83 0 0 0 3.03-5.76c.25 0 .4.01.43.04.06.04.11.16.14.39-.35.86-.78 1.8-1.3 2.83-.47 1-1.03 1.95-1.67 2.88-.61.93-1.3 1.68-2.07 2.26-.73.57-1.55.86-2.44.86-.8 0-1.46-.29-1.97-.86a3.83 3.83 0 0 1-.77-2.55c0-.86.16-1.79.48-2.78-.54.96-1.17 1.92-1.87 2.88-.7.96-1.46 1.76-2.26 2.4-.8.6-1.6.91-2.4.91Zm19.16.2a5.02 5.02 0 0 1-3.21-1.16c-.93-.77-1.4-1.94-1.4-3.5 0-1.32.3-2.7.87-4.18.6-1.47 1.4-2.85 2.35-4.13 1-1.31 2.08-2.37 3.27-3.17a6.43 6.43 0 0 1 3.64-1.24c.61 0 1.2.17 1.78.52.58.36.86.96.86 1.83 0 .8-.3 1.68-.9 2.64-.62.96-1.48 1.85-2.6 2.69-.48.35-1.09.68-1.82 1-.74.32-1.48.6-2.21.82-.74.2-1.35.29-1.83.29-.16.38-.32.9-.48 1.53-.12.64-.19 1.3-.19 1.97 0 .8.16 1.52.48 2.16.32.64.91.96 1.78.96a5.1 5.1 0 0 0 2.93-.91 9.82 9.82 0 0 0 2.44-2.3c.74-.93 1.36-1.88 1.88-2.84a33 33 0 0 0 1.2-2.44c.38 0 .57.14.57.43-.41.9-.9 1.87-1.44 2.93a16.03 16.03 0 0 1-1.87 2.97c-.7.9-1.57 1.65-2.6 2.26-.98.57-2.15.86-3.5.86Zm-.86-8.46a9.1 9.1 0 0 0 5.14-2.1 8.35 8.35 0 0 0 1.92-2.4c.44-.9.67-1.66.67-2.26 0-.7-.26-1.06-.77-1.06-.38 0-.91.26-1.58.77a16.4 16.4 0 0 0-2.5 2.59c-.6.77-1.18 1.6-1.73 2.5-.54.9-.93 1.55-1.15 1.96Zm10.7 8.45c-1.31 0-2.39-.4-3.22-1.2-.8-.83-1.2-1.7-1.2-2.59 0-.74.2-1.4.58-2.02.35-.64.83-.96 1.44-.96l.05-.1c.7-1.27 1.37-2.57 2.01-3.88.67-1.34 1.41-2.77 2.21-4.27a14 14 0 0 1 2.16-3.07c.8-.8 1.73-1.2 2.78-1.2.26 0 .61.06 1.06.19.45.1.67.32.67.67 0 .26-.14.38-.43.38-.22 0-.48-.06-.77-.19a1.5 1.5 0 0 0-.62-.19c-.61 0-1.12.35-1.54 1.06-.41.7-.62 1.45-.62 2.25 0 .87.14 1.65.43 2.35.29.68.62 1.33 1 1.97.4.64.73 1.3 1.02 1.97.28.64.43 1.34.43 2.11a6.9 6.9 0 0 1-.91 3.75 5.63 5.63 0 0 1-2.3 2.1h.04a4.9 4.9 0 0 0 4.18-2.34 34.6 34.6 0 0 0 3.3-6.24c.4 0 .58.14.58.43a51.06 51.06 0 0 1-2.01 4.22 12.44 12.44 0 0 1-2.6 3.41c-.99.9-2.2 1.34-3.64 1.34-.61 0-1.17-.06-1.68-.19-.74.16-1.54.24-2.4.24Zm-.72-5.09c0 .77.17 1.5.53 2.21.35.7.99 1.23 1.92 1.59A4.67 4.67 0 0 0 73 36.69c.48-1.03.72-2.08.72-3.17 0-.9-.1-1.8-.3-2.74-.18-.92-.4-1.84-.62-2.73-.19-.9-.28-1.7-.28-2.4v-.58l.1-.53c-.58.87-1.18 1.88-1.78 3.03l-1.68 3.31a27.36 27.36 0 0 1-1.5 2.6c.65.09.97.63.97 1.62Zm-1.59 2.4c0 .52.18.96.53 1.35.35.38.88.57 1.59.57.32 0 .62-.03.9-.1a5.15 5.15 0 0 1-1.62-1.58 4.2 4.2 0 0 1-.58-2.2 3.09 3.09 0 0 0-.82 1.96Zm15.1 2.7c-1.3 0-2.38-.4-3.21-1.2-.8-.84-1.2-1.7-1.2-2.6 0-.74.2-1.4.57-2.02.36-.64.84-.96 1.44-.96l.05-.1c.7-1.27 1.38-2.57 2.02-3.88.67-1.34 1.4-2.77 2.2-4.27a14 14 0 0 1 2.17-3.07c.8-.8 1.72-1.2 2.78-1.2.26 0 .6.06 1.06.19.44.1.67.32.67.67 0 .26-.15.38-.43.38-.23 0-.48-.06-.77-.19a1.5 1.5 0 0 0-.63-.19c-.6 0-1.12.35-1.53 1.06-.42.7-.63 1.45-.63 2.25 0 .87.15 1.65.44 2.35.28.68.62 1.33 1 1.97.39.64.72 1.3 1.01 1.97.3.64.43 1.34.43 2.11a6.9 6.9 0 0 1-.9 3.75 5.63 5.63 0 0 1-2.31 2.1h.05a4.9 4.9 0 0 0 4.17-2.34 34.6 34.6 0 0 0 3.31-6.24c.39 0 .58.14.58.43a51.06 51.06 0 0 1-2.02 4.22 12.44 12.44 0 0 1-2.59 3.41c-.99.9-2.2 1.34-3.65 1.34-.6 0-1.16-.06-1.68-.19-.73.16-1.53.24-2.4.24Zm-.72-5.1c0 .77.18 1.5.53 2.21.35.7 1 1.23 1.92 1.59a4.67 4.67 0 0 0 1.92-2.21c.48-1.03.72-2.08.72-3.17 0-.9-.1-1.8-.29-2.74-.19-.92-.4-1.84-.62-2.73-.2-.9-.29-1.7-.29-2.4v-.58l.1-.53c-.58.87-1.17 1.88-1.78 3.03-.57 1.15-1.13 2.25-1.68 3.31a27.36 27.36 0 0 1-1.49 2.6c.64.09.96.63.96 1.62Zm-1.58 2.4c0 .52.18.96.53 1.35.35.38.88.57 1.58.57.32 0 .63-.03.91-.1a5.15 5.15 0 0 1-1.63-1.58 4.2 4.2 0 0 1-.57-2.2 3.09 3.09 0 0 0-.82 1.96Zm17.64 2.74c1.18-2.27 2.3-4.54 3.36-6.82 1.06-2.3 2.13-4.48 3.22-6.52a13.3 13.3 0 0 1 1.58-2.4 2.31 2.31 0 0 1 1.78-.72c.25 0 .52.04.81.14.3.06.58.1.87.1.19 0 .33-.02.43-.05-.45.25-1.03.9-1.73 1.92-.7.99-1.42 2.14-2.16 3.45a88.4 88.4 0 0 0-1.97 3.7c.61-.74 1.23-1.47 1.88-2.2.67-.74 1.4-1.45 2.2-2.12.7-.6 1.44-1.26 2.21-1.97.8-.73 1.59-1.36 2.35-1.87a3.8 3.8 0 0 1 2.02-.77c.22 0 .37.02.43.05.6.26.91.67.91 1.25 0 .19-.08.48-.24.86a23 23 0 0 1-1.63 3.36 69.64 69.64 0 0 0-1.82 3.41l1.77-2.11a23.94 23.94 0 0 1 4.9-4.23c1.09-.7 2.16-1.3 3.21-1.82a6.28 6.28 0 0 1 2.55-.77c.22 0 .38.02.48.05l-.53.96a80.27 80.27 0 0 0-4.42 8.93 13.65 13.65 0 0 0-.81 2.59c-.1.42-.14.8-.14 1.15 0 .51.1.85.28 1.01.2.16.4.24.63.24a2.8 2.8 0 0 0 1.87-.82c.64-.54 1.26-1.23 1.87-2.06a21.3 21.3 0 0 0 1.63-2.74c.52-.96.95-1.85 1.3-2.68.38 0 .58.14.58.43-.36.86-.8 1.82-1.35 2.88-.51 1.02-1.1 2-1.77 2.93-.68.92-1.41 1.7-2.21 2.3-.8.6-1.67.91-2.6.91-.67 0-1.3-.22-1.91-.67-.58-.45-.87-1.28-.87-2.5 0-1.3.3-2.62.91-3.93.64-1.31 1.3-2.51 1.97-3.6.32-.55.48-.98.48-1.3 0-.38-.2-.57-.58-.57-.31 0-.76.16-1.34.48-.54.32-1.23.88-2.06 1.68-.51.48-1.12 1.15-1.83 2.01-.67.83-1.36 1.75-2.06 2.74-.7.99-1.31 1.97-1.83 2.93-.5.96-.84 1.8-1 2.54-.48 0-.87-.2-1.16-.58-.28-.41-.43-.9-.43-1.44v-.28a8.2 8.2 0 0 1 .82-2.83 199 199 0 0 0 1.2-2.45l.77-1.44c.28-.58.54-1.12.77-1.64.22-.54.33-.99.33-1.34 0-.32-.13-.48-.38-.48-.3 0-.67.14-1.16.43-.44.29-.88.63-1.3 1.01l-.95.82c-.8.76-1.78 1.87-2.93 3.3a38.91 38.91 0 0 0-3.7 6.15c-.19.35-.41.58-.67.67-.25.07-.65.1-1.2.1h-.86c-.26.03-.51.11-.77.24Zm32.53-.05a5.02 5.02 0 0 1-3.21-1.15c-.93-.77-1.4-1.94-1.4-3.5 0-1.32.3-2.7.87-4.18.6-1.47 1.4-2.85 2.35-4.13 1-1.31 2.08-2.37 3.27-3.17a6.43 6.43 0 0 1 3.65-1.24c.6 0 1.2.17 1.77.52.58.36.87.96.87 1.83 0 .8-.3 1.68-.92 2.64-.6.96-1.47 1.85-2.59 2.69-.48.35-1.09.68-1.82 1-.74.32-1.47.6-2.21.82-.74.2-1.34.29-1.82.29-.16.38-.32.9-.48 1.53-.13.64-.2 1.3-.2 1.97 0 .8.16 1.52.48 2.16.32.64.91.96 1.78.96a5.1 5.1 0 0 0 2.93-.91 9.82 9.82 0 0 0 2.44-2.3c.74-.93 1.36-1.88 1.88-2.84a33 33 0 0 0 1.2-2.44c.38 0 .57.14.57.43-.41.9-.9 1.87-1.44 2.93a16.03 16.03 0 0 1-1.87 2.97c-.7.9-1.57 1.65-2.6 2.26-.98.57-2.15.86-3.5.86Zm-.86-8.45a9.1 9.1 0 0 0 5.14-2.1 8.35 8.35 0 0 0 1.92-2.4c.44-.9.67-1.66.67-2.26 0-.7-.26-1.06-.77-1.06-.38 0-.91.26-1.58.77a16.4 16.4 0 0 0-2.5 2.59c-.6.77-1.18 1.6-1.73 2.5-.54.9-.93 1.55-1.15 1.96Zm11.95 8.4c-1.19 0-2.07-.35-2.64-1.05a4.24 4.24 0 0 1-.82-2.6c0-1.02.14-2.07.43-3.16.29-1.09.55-2 .77-2.74a70.6 70.6 0 0 1 1.92-5.71c.8-2.05 1.66-4.05 2.6-6 .95-1.98 1.9-3.76 2.82-5.33a9.13 9.13 0 0 1 2.36-2.78c.86-.64 1.61-.96 2.25-.96.51 0 .91.19 1.2.57.32.36.48.9.48 1.64a12.3 12.3 0 0 1-1.15 4.22c-1.12 2.5-2.46 5-4.03 7.49a33.1 33.1 0 0 1-5.86 7 19 19 0 0 0-.96 2.89 10.8 10.8 0 0 0-.38 2.5c0 1.98.67 2.97 2.01 2.97 1.03 0 2.16-.74 3.41-2.21a25.52 25.52 0 0 0 3.55-6.14c.13 0 .26.03.39.1.13.02.19.14.19.33-.35.86-.8 1.82-1.34 2.88a18.6 18.6 0 0 1-1.83 2.93 9.45 9.45 0 0 1-2.35 2.3c-.9.58-1.9.86-3.02.86Zm.72-10.94a34.1 34.1 0 0 0 3.36-4.08 58.37 58.37 0 0 0 5.42-9.65c.22-.48.4-1 .53-1.58.16-.58.24-1.06.24-1.44 0-.45-.11-.67-.34-.67-.13 0-.32.12-.57.38-.26.22-.6.62-1.01 1.2-.61.8-1.28 1.89-2.02 3.26a144.73 144.73 0 0 0-4.17 8.98 83.42 83.42 0 0 0-1.44 3.6ZM151.94 40c-1.31 0-2.29-.46-2.93-1.4a6.33 6.33 0 0 1-.91-3.45c0-1.25.24-2.54.72-3.89a15.13 15.13 0 0 1 2.11-4.03c.93-1.21 1.94-2.19 3.03-2.93a5.85 5.85 0 0 1 3.3-1.15c1.32 0 2.28.45 2.89 1.35.64.9.96 2.03.96 3.4 0 .96-.16 1.97-.48 3.03a17.4 17.4 0 0 1-1.3 3.12c.42.41 1 .62 1.78.62.9 0 1.66-.29 2.3-.86a8.62 8.62 0 0 0 1.87-3.07c.39 0 .58.14.58.43a8.73 8.73 0 0 1-2.11 3.26c-.77.67-1.76 1-2.98.96-.74 0-1.34-.2-1.82-.62a14.63 14.63 0 0 1-3.22 3.74 5.94 5.94 0 0 1-3.8 1.49Zm.67-1.06c.74 0 1.47-.3 2.2-.9a14.39 14.39 0 0 0 3.32-4.23 8.77 8.77 0 0 1-.91-2.07c-.06-.48-.1-.83-.1-1.05 0-.61.16-1.07.48-1.4.32-.31.64-.47.96-.47.45 0 .84.19 1.16.57l.14-.96c.03-.32.05-.62.05-.91 0-.83-.16-1.5-.48-2.02a1.46 1.46 0 0 0-1.4-.81c-.67 0-1.37.29-2.1.86-.74.58-1.45 1.35-2.12 2.3a17.9 17.9 0 0 0-1.68 3.22c-.41 1-.73 1.94-.96 2.83a9.6 9.6 0 0 0-.33 2.4c0 .8.14 1.44.43 1.92.28.48.73.72 1.34.72ZM176.27 40c-1.09 0-1.89-.37-2.4-1.1a4.42 4.42 0 0 1-.77-2.6 7.82 7.82 0 0 1 .24-1.82c-.45.7-.97 1.49-1.58 2.35-.58.83-1.25 1.57-2.02 2.21a3.81 3.81 0 0 1-3.94.62c-.5-.19-.97-.56-1.39-1.1a4.15 4.15 0 0 1-.57-2.4c0-1.38.3-2.83.9-4.37.62-1.53 1.45-2.97 2.5-4.32a13.5 13.5 0 0 1 3.6-3.31 7.62 7.62 0 0 1 4.18-1.3c1.15 0 2.24.3 3.26.92.48-.9 1-1.9 1.54-2.98l1.63-3.31a115.02 115.02 0 0 0 2.4-5.09c.48-1.12.93-1.82 1.35-2.11.45-.32.97-.48 1.58-.48.35 0 .74.05 1.15.14.45.07.88.08 1.3.05-.16.16-.53.69-1.1 1.58a290.16 290.16 0 0 0-4.8 8.16 182.8 182.8 0 0 0-5.28 10.32 50.13 50.13 0 0 0-1.83 4.32 9.3 9.3 0 0 0-.67 2.84c0 .41.1.78.29 1.1.19.29.5.43.96.43.6 0 1.23-.3 1.87-.91.64-.6 1.25-1.36 1.82-2.26.61-.92 1.14-1.82 1.59-2.68.48-.9.83-1.62 1.05-2.16.39 0 .58.14.58.43-.29.67-.67 1.5-1.15 2.5-.48.99-1.04 1.96-1.68 2.92a11.5 11.5 0 0 1-2.16 2.45c-.77.64-1.59.96-2.45.96Zm-8.69-1.44c.45 0 1-.24 1.68-.72.67-.51 1.4-1.31 2.16-2.4.9-1.28 1.92-2.88 3.07-4.8 1.16-1.92 2.3-3.95 3.41-6.1a2.4 2.4 0 0 0-.72-.43 3.1 3.1 0 0 0-1.06-.14c-.73 0-1.55.32-2.44.96-.87.6-1.75 1.4-2.64 2.4a24 24 0 0 0-4.13 6.58 7.67 7.67 0 0 0-.63 2.73c0 1.28.44 1.92 1.3 1.92Zm8.93 16.75c-1.66 0-2.84-.33-3.55-1A3 3 0 0 1 171.9 52c0-1.38.52-2.66 1.54-3.84 1-1.15 2.22-2.08 3.7-2.78 1.66-.77 3.55-1.4 5.66-1.88 2.14-.48 4.2-1 6.14-1.58a25.2 25.2 0 0 0 1.69-3.6 100.65 100.65 0 0 0 2.4-7.2c-.39.7-.88 1.57-1.5 2.6-.57.98-1.22 1.96-1.96 2.92s-1.54 1.76-2.4 2.4c-.83.64-1.71.96-2.64.96a4.5 4.5 0 0 1-1.3-.24 3.08 3.08 0 0 1-1.3-.86 3.14 3.14 0 0 1-.52-1.97c0-.83.25-1.75.77-2.74a264.6 264.6 0 0 1 1.53-3.02c-.16 0-.3-.02-.43-.05-.1-.03-.14-.16-.14-.38a337.99 337.99 0 0 1 1.54-3.36l1-2.02c.35-.74.74-1.25 1.15-1.54a2.4 2.4 0 0 1 1.3-.43h2.97c-.22.2-.5.42-.86.67a3.4 3.4 0 0 0-.91 1.06 50.75 50.75 0 0 0-2.26 4.27l-2.06 4.32c-.35.74-.6 1.41-.77 2.02-.16.6-.24 1.13-.24 1.58 0 1.06.35 1.59 1.06 1.59.76 0 1.7-.63 2.78-1.88.9-1.05 1.8-2.3 2.69-3.74a98.66 98.66 0 0 0 4.9-8.83c.35-.7.97-1.06 1.87-1.06h2.64a6.52 6.52 0 0 0-2.16 2.5 58.51 58.51 0 0 0-1.63 3.93c-.68 1.76-1.32 3.59-1.93 5.48-.6 1.88-1.28 3.82-2.01 5.8a12.76 12.76 0 0 0 3.94-2.1 12.44 12.44 0 0 0 2.78-3.32 41.57 41.57 0 0 0 2.5-4.94c.38 0 .57.14.57.43-.7 1.47-1.34 2.77-1.92 3.89a17 17 0 0 1-1.92 2.97c-.7.83-1.58 1.6-2.64 2.3a20.84 20.84 0 0 1-4.08 2.12 59.98 59.98 0 0 1-2.64 4.27c-.96 1.5-2.06 2.9-3.31 4.18a15.41 15.41 0 0 1-4.08 3.16 9.78 9.78 0 0 1-4.9 1.25Zm-1.15-.96c1.06 0 2.14-.32 3.26-.96 1.13-.64 2.21-1.45 3.27-2.45a31.36 31.36 0 0 0 2.88-2.97c.9-1 1.61-1.87 2.16-2.64.16-.23.33-.51.53-.87l.57-1-5.18 1.34a35.31 35.31 0 0 0-4.85 1.68 8.26 8.26 0 0 0-3.6 2.74c-.9 1.18-1.34 2.24-1.34 3.16 0 .58.19 1.04.57 1.4.36.38.93.57 1.73.57Z"
    />
  </svg>
);

export const user = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="user"
  >
    <path
      d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 11C14.7091 11 16.5 9.20914 16.5 7C16.5 4.79086 14.7091 3 12.5 3C10.2909 3 8.5 4.79086 8.5 7C8.5 9.20914 10.2909 11 12.5 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const circle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="timer"
    viewBox="0 0 780 780"
  >
    <circle
      className="timer__line"
      cx="390"
      cy="390"
      r="370"
      style={{
        filter: 'url(#blur)',
        transform: 'rotate(-90deg) scaleY(-1)',
        transformOrigin: 'center',
      }}
    />
  </svg>
);

export const circleCheck = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="circle-check"
  >
    <path
      d="M22.5 11.08V12C22.4988 14.1564 21.8005 16.2547 20.5093 17.9818C19.2182 19.709 17.4033 20.9725 15.3354 21.5839C13.2674 22.1953 11.0573 22.1219 9.03447 21.3746C7.01168 20.6273 5.28465 19.2461 4.11096 17.4371C2.93727 15.628 2.37979 13.4881 2.52168 11.3363C2.66356 9.18455 3.49721 7.13631 4.89828 5.49706C6.29935 3.85781 8.19279 2.71537 10.2962 2.24013C12.3996 1.7649 14.6003 1.98232 16.57 2.85999"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 4L12.5 14.01L9.5 11.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const info = (
  <svg
    className="info"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8H12.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const eyeOpen = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="eye-open"
  >
    <path
      d="M1 10C1 10 4 4 10 4C16 4 19 10 19 10C19 10 16 16 10 16C4 16 1 10 1 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10"
      cy="10"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const eyeClosed = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="eye-closed"
  >
    <path
      d="M14.12 14.12C12.8 15.14 11.44 15.5 10 15.5C4 15.5 1 10 1 10C2.24 7.87 4.07 6.18 6.38 5.27"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.21 8.21C8.41 7.73 8.76 7.31 9.21 7.01C9.66 6.71 10.19 6.55 10.73 6.55C11.27 6.55 11.8 6.71 12.25 7.01C12.7 7.31 13.05 7.73 13.25 8.21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 10C18.18 11.65 16.69 13.05 14.12 14.12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="1"
      y1="1"
      x2="19"
      y2="19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
